import TermsComponent from '../components/Terms';

const Terms = () => {
  return <TermsComponent />;
};

export default Terms;
